export const MAX_SLIDE_COUNT = 100
export const MAX_SLIDE_COUNT_MESSAGE = `最多只能添加 ${MAX_SLIDE_COUNT} 页幻灯片`
